/**
 * Regex to check address line includes only numbers and hyphens
 */
export const AddressLineNumberHyphenOnlyRegex: RegExp = /^[0-9\uFF10-\uFF19]+([-−][0-9\uFF10-\uFF19]+){0,2}$/;
